export const pppEnabledSubVerticals = [
  'tv-and-home-entertainment',
  'computing',
  'audio',
  'cameras',
  'wearable-technology',
  'car-technology',
  'garden-and-outdoors',
  'travel-and-transport',
  'travel-product-reviews',
  'destinations',
  'hotels',
  'planning-your-trip',
]
